import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white section-padding">
        <div className="container-custom">
          <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              {t('terms.title')}
            </h1>
            <p className="text-xl text-gray-200">
              {t('terms.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              <div className="bg-white rounded-lg shadow-lg p-8">
                <div className="mb-8">
                  <p className="text-gray-600 text-sm mb-4">
                    {t('terms.lastUpdated')}: {new Date().toLocaleDateString()}
                  </p>
                </div>

                <div className="space-y-8">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.acceptance.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('terms.sections.acceptance.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.services.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {t('terms.sections.services.content')}
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                      <li>{t('terms.sections.services.items.roadTransport')}</li>
                      <li>{t('terms.sections.services.items.seaFreight')}</li>
                      <li>{t('terms.sections.services.items.temperatureControlled')}</li>
                      <li>{t('terms.sections.services.items.logistics')}</li>
                    </ul>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.responsibilities.title')}
                    </h2>
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">
                          {t('terms.sections.responsibilities.client.title')}
                        </h3>
                        <ul className="list-disc list-inside text-gray-700 space-y-1">
                          <li>{t('terms.sections.responsibilities.client.items.accurate')}</li>
                          <li>{t('terms.sections.responsibilities.client.items.packaging')}</li>
                          <li>{t('terms.sections.responsibilities.client.items.documentation')}</li>
                          <li>{t('terms.sections.responsibilities.client.items.payment')}</li>
                        </ul>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">
                          {t('terms.sections.responsibilities.company.title')}
                        </h3>
                        <ul className="list-disc list-inside text-gray-700 space-y-1">
                          <li>{t('terms.sections.responsibilities.company.items.professional')}</li>
                          <li>{t('terms.sections.responsibilities.company.items.timely')}</li>
                          <li>{t('terms.sections.responsibilities.company.items.safety')}</li>
                          <li>{t('terms.sections.responsibilities.company.items.communication')}</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.pricing.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('terms.sections.pricing.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.liability.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('terms.sections.liability.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.termination.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('terms.sections.termination.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.disputes.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('terms.sections.disputes.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.changes.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('terms.sections.changes.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('terms.sections.contact.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {t('terms.sections.contact.content')}
                    </p>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="text-gray-700">
                                    <strong>K&BTrans</strong><br />
            {t('contact.email')}: info@kbtrans.eu<br />
                        {t('contact.phone')}: +48 577 083 279
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms; 